import { Injectable } from '@angular/core'
import { RemoteConfig } from '@angular/fire/remote-config'
import { fetchAndActivate, getValue } from 'firebase/remote-config'
import { BehaviorSubject, interval, Subscription } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  private pollingSubscription: Subscription | null = null
  private maintenanceModeSubject = new BehaviorSubject<boolean>(false)
  public isMaintenanceMode$ = this.maintenanceModeSubject.asObservable()

  constructor(private remoteConfig: RemoteConfig) {
    this.initializeRemoteConfig()
  }

  private async initializeRemoteConfig() {
    try {
      this.remoteConfig.settings = {
        minimumFetchIntervalMillis: 300000, // 5分
        fetchTimeoutMillis: 60000, // 1分
      }

      this.remoteConfig.defaultConfig = {
        maintenance_mode: false,
      }

      await this.fetchAndUpdateConfig()

      if (this.pollingSubscription) {
        this.pollingSubscription.unsubscribe()
      }
      // 1分ごとに定期チェック
      this.pollingSubscription = interval(60000).subscribe(async () => {
        try {
          await this.fetchAndUpdateConfig()
        } catch (error) {
          console.error('Periodic maintenance check failed:', error)
        }
      })
    } catch (error) {
      console.error('Remote Config initialization failed:', error)
    }
  }

  private async fetchAndUpdateConfig(): Promise<void> {
    try {
      await fetchAndActivate(this.remoteConfig)
      const isMaintenanceMode = getValue(
        this.remoteConfig,
        'maintenance_mode',
      ).asBoolean()

      // 状態が変わった場合のみ通知
      if (this.maintenanceModeSubject.value !== isMaintenanceMode) {
        this.maintenanceModeSubject.next(isMaintenanceMode)
      }
    } catch (error) {
      console.error('Failed to fetch maintenance config:', error)
      throw error
    }
  }

  // 現在の状態を同期的に取得
  getCurrentMaintenanceMode(): boolean {
    return this.maintenanceModeSubject.value
  }

  // 手動リフレッシュ
  async refreshConfig(): Promise<void> {
    await this.fetchAndUpdateConfig()
  }
}
